<template>
    <div class="filter-item filter-item--price-filter" v-show="loaded" v-if="!isSame">
        <h2 class="filter-item__heading" v-text="translations.title"></h2>
        <vue-slider v-if="showSlider" v-model="priceSpan" :min="minPrice" :max="maxPrice" :tooltip="false" :interval="interval" :debug="debug"></vue-slider>

        <div class="filter-item__flex">
            <p class="filter-item__price-text"><span v-price="shownMinPrice"></span> {{ minPriceData.currency }}</p>
            <p class="filter-item__price-text"><span v-price="shownMaxPrice"></span> {{ maxPriceData.currency }}</p>
        </div>
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import currencyFormatter from 'currency-formatter';
import _ from 'underscore';
import { trackEvent } from '../../tracker';

export default {
    props: {
        showSlider: {type: Boolean, default: false}
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.PRICE_FILTER,
            priceSpan: [null, null],
            shownChange: {type: Boolean, default: false},
            updateTimeout: null
        }
    },
    mounted() {
        if(this.loaded) {
            this.readPriceSpan();
        }
    },
    methods: {
        readPriceSpan() {
            let query = this.$route.query;

            if(!query.minPrice) {
                this.$set(this.priceSpan, 0, this.minPrice);
            } else if(parseFloat(query.minPrice) > this.minPrice) {
                this.$set(this.priceSpan, 0, parseFloat(query.minPrice) || null);
            } else {
                this.$set(this.priceSpan, 0, this.minPrice);
            }

            if(!query.maxPrice) {
                this.$set(this.priceSpan, 1, this.maxPrice);
            } else if(parseFloat(query.maxPrice) < this.maxPrice) {
                this.$set(this.priceSpan, 1, parseFloat(query.maxPrice) || null);
            } else {
                this.$set(this.priceSpan, 1, this.maxPrice);
            }
        },
        format(value) {
            return currencyFormatter.format(value, {
                "symbol": this.minPriceData.currency || 'DKK',
                "thousand": ".",
                "decimal": ",",
                "precision": 0,
                "format": '%v %s'
            });
        }
    },
    watch: {
        '$route.query.minPrice'() {
            if(this.loaded) {
                this.readPriceSpan();
            }
        },
        '$route.query.maxPrice'() {
            if(this.loaded) {
                this.readPriceSpan();
            }
        },
        loaded() {
            if(this.loaded) {
                this.readPriceSpan();
            }
        },
        priceSpan(newValue, oldValue) {
                if(!this.priceSpan[0] || !this.priceSpan[1]) {
                    return;
                }

                if(this.priceSpan[0] == this.priceSpan[1]) {
                    return;
                }

                if(_.isEqual(newValue, oldValue)) {
                    return;
                }

                if(this.updateTimeout) {
                    clearTimeout(this.updateTimeout);
                }

                this.updateTimeout = setTimeout(() => {
                    if(this.loaded) {
                        let query = Object.assign({}, this.$route.query);
                        query.minPrice = this.priceSpan[0];
                        query.maxPrice = this.priceSpan[1];             
                        
                        this.$router.replace({query}, (to, from, next) => {
                            trackEvent({
                                event: 'Filter - Pris',
                                target: to.fullPath,
                                value: {
                                    minPrice: this.priceSpan[0],
                                    maxPrice: this.priceSpan[1]
                                },
                                destination: (this.$store) ? this.$store.state.destination : null,
                                'interaction-type': 'noninteraction',
                            })
                        });
                    }
                }, 500);
        }
    },
    computed: {
        isSame() {
            return (this.minPrice === this.maxPrice);
        },
        debug() {
            return !APP_CONFIG.IS_PRODUCTION;
        },
        interval() {
            return 1000;
        },
        loaded() {
            return (!_.isEmpty(this.minPriceData) && !_.isEmpty(this.maxPriceData)) ? true :false;
        },
        shownMinPrice() {
            return (this.priceSpan[0]) ? this.priceSpan[0] : this.minPrice;
        },
        shownMaxPrice() {
            return (this.priceSpan[1]) ? this.priceSpan[1] : this.maxPrice;
        },
        minPrice() {
            return this.minPriceData.value || 0;
        },
        maxPrice() {
            return this.maxPriceData.value || 0;
        },
        minPriceData() {
            return this.$store.state.filters.minPrice || { };
        },
        maxPriceData() {
            return this.$store.state.filters.maxPrice || { };
        }
    },
    components: {
        VueSlider
    }
}
</script>
